module.exports = __webpack_public_path__ + "img/bgr-home-art.1e70e2bc.jpg";